module.exports = __webpack_public_path__ + "img/img3.8a7aa086.jpg";